import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    occurrenceReasonToEditId: null
  },

  mutations: {
    CLEAN_OCCURRENCE_REASON_TO_EDIT (state) {
      state.occurrenceReasonToEditId = null
    },
    OCCURRENCE_REASON_TO_EDIT_SELECTED (state, occurrenceReasonToEditId) {
      state.occurrenceReasonToEditId = occurrenceReasonToEditId
    }
  },

  actions: {
    saveOccurrenceReason: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/occurrenceReason/saveOccurrenceReason', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getOccurrenceReasons: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(url).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getOccurrenceReason: ({ commit }, occurrenceReasonId) => {
      return new Promise((resolve, reject) => {
        axios.get('/occurrenceReason/find', { params: { occurrenceReasonId: occurrenceReasonId } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setOccurrenceReasonToEdit: ({ commit }, occurrenceReasonId) => {
      return new Promise((resolve, reject) => {
        commit('OCCURRENCE_REASON_TO_EDIT_SELECTED', occurrenceReasonId)
        resolve()
      })
    },

    cleanOccurrenceReasonToEdit: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_OCCURRENCE_REASON_TO_EDIT')
        resolve()
      })
    },

    removeOccurrenceReason: ({ commit }, occurrenceReasonId) => {
      return new Promise((resolve, reject) => {
        axios.delete('/occurrenceReason/removeOccurrenceReason', {params: { occurrenceReasonId: occurrenceReasonId }}).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
    occurrenceReasonToEditId: state => state.occurrenceReasonToEditId
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/occurrenceReason.js